import styles from '../../assets/css/accounts.module.css';

interface IBANProps {
	iban: string;
}

const IBAN = ({ iban }: IBANProps) => {
	return (
		<div className={styles['iban-container']}>
			<span className={styles['iban']}>{iban}</span>
		</div>
	);
};

export default IBAN;
